import {
	Card,
	makeStyles,
	Tooltip, Box
} from '@material-ui/core';
import * as dayjs from 'dayjs';
import React from 'react';
import { useActions, useValues } from 'kea';

import { rsummarylogic } from 'src/store/report';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";

import SummaryDataDialog from './AddDataDialogs/SummaryDialog';
// import CSVDialog from './CSVDialog';
// import PDFDialog from './PDFDialog';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';
import prettytime from 'src/utils/prettytime';

const useStyles = makeStyles({
	root: {
		width: "100%",
		height: '631px'
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		name: 'type',
		label: 'Type',
		align: 'left',
		width: 110,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'name',
		label: 'Name',
		align: 'left',
		width: 180,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'registration_number',
		label: 'Registration No.',
		align: 'left',
		width: 160,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'info',
		label: 'Vehicle Details',
		align: 'left',
		width: 250,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'distance_traveled',
		label: 'Distance',
		align: 'left',
		width: 140,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'running_time',
		label: 'Driving Time',
		align: 'left',
		width: 250,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'tow_time',
		label: 'Tow Time',
		align: 'left',
		width: 250,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'idle_time',
		label: 'Idle Time',
		align: 'left',
		width: 250,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'stopped_time',
		label: 'Stopped Time',
		align: 'left',
		width: 250,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
];


const initialRowsPerPage = 10;
const Summary = () => {
	const classes = useStyles();
	const { report, query } = useValues(rsummarylogic);
	const [data, setData] = React.useState([]);

	React.useEffect(() => {
		if (report.length > 0) {
			let newRows = report.map((row, count) => {
				return {
					id: count,
					type: row.vehicle.type,
					name: row.vehicle.name,
					registration_number: row.vehicle.registration_number,
					info: `${row.vehicle.year} ${row.vehicle.company} ${row.vehicle.model} ${row.vehicle.color}`,
					distance_traveled: `${row.distance / 1000} KMs`,
					running_time: prettytime(row.ignition_time),
					idle_time: prettytime(row.idle_time),
					tow_time: prettytime(row.towing_time),
					stopped_time: prettytime(row.stopped_time)
				}
			});
			setData(newRows);
		}
	}, [report]);

	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				<PrintToolbarPlugin
					title='Summary Report'
					context={{
						head: [['Start Time', 'End Time']],
						body: [[dayjs(query?.start).format('DD-MM-YYYY'), dayjs(query?.stop).format('DD-MM-YYYY')]]
					}}
					rows={data}
					columns={columns}
					filename={`Summary_Report [${dayjs(query?.start).format('YYYY-MM-DD')}-to-${dayjs(query?.stop).format('YYYY-MM-DD')}]`}
				/>
				<CSVToolbarPlugin
					rows={data}
					columns={columns}
					filename={`Summary_Report [${dayjs(query?.start).format('YYYY-MM-DD')}-to-${dayjs(query?.stop).format('YYYY-MM-DD')}]`}
				/>
				<SummaryDataDialog />
			</span>
	};

	return (
		<>
			<Box mt={1}>
				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Vehicle Summary Report"}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</>
	);
};


export default Summary;
